"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAbbreviatedMonthName = exports.isAfterDate = exports.formatDate = exports.isDateBeforeToday = exports.isDateInRange = exports.isSameDate = exports.getNumFirstDay = exports.getNumDaysInAMonth = exports.getDiff = exports.getFormattedDate = exports.generateMonthsDate = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _isBetween = _interopRequireDefault(require("dayjs/plugin/isBetween"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dayjs["default"].extend(_isBetween["default"]);

var generateMonthsDate = function generateMonthsDate(date, numberOfMonths) {
  return Array.from({
    length: numberOfMonths + 1
  }).map(function (_, idx) {
    return new Date(date.getFullYear(), date.getMonth() + idx);
  });
};

exports.generateMonthsDate = generateMonthsDate;

var formatDate = function formatDate(formatter) {
  return function (date) {
    return (0, _dayjs["default"])(date).format(formatter);
  };
};

exports.formatDate = formatDate;

var getFormattedDate = function getFormattedDate(startDate, endDate, formatter) {
  var format = formatDate(formatter);
  var res = '';
  if (startDate) res = "".concat(format(startDate), " - ");
  if (endDate) res += format(endDate);
  return res;
};

exports.getFormattedDate = getFormattedDate;

var getDiff = function getDiff(startDate, endDate) {
  return (0, _dayjs["default"])(endDate).diff((0, _dayjs["default"])(startDate), 'days');
};

exports.getDiff = getDiff;
var MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

var getAbbreviatedMonthName = function getAbbreviatedMonthName(monthNum) {
  return MONTH_NAMES[monthNum];
};

exports.getAbbreviatedMonthName = getAbbreviatedMonthName;

var getNumDaysInAMonth = function getNumDaysInAMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
};

exports.getNumDaysInAMonth = getNumDaysInAMonth;

var getNumFirstDay = function getNumFirstDay(year, numMonth) {
  return new Date(year, numMonth, 1).getDay();
};

exports.getNumFirstDay = getNumFirstDay;

var isDateInRange = function isDateInRange(startDate, endDate) {
  return function (dateToCheck) {
    return (0, _dayjs["default"])(dateToCheck).isBetween((0, _dayjs["default"])(startDate), (0, _dayjs["default"])(endDate));
  };
};

exports.isDateInRange = isDateInRange;

var isSameDate = function isSameDate(dateToBeChecked) {
  return function (date) {
    return (0, _dayjs["default"])(date).isSame((0, _dayjs["default"])(dateToBeChecked));
  };
};

exports.isSameDate = isSameDate;
var YESTERDAY = (0, _dayjs["default"])().subtract(1, 'day');

var isDateBeforeToday = function isDateBeforeToday(date) {
  return (0, _dayjs["default"])(date).isBefore(YESTERDAY);
};

exports.isDateBeforeToday = isDateBeforeToday;

var isAfterDate = function isAfterDate(startDate) {
  return function (date) {
    return (0, _dayjs["default"])(startDate).isAfter(date);
  };
};

exports.isAfterDate = isAfterDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@honeyguide/components/dist/components/DateRangePicker/helpers.js
// module id = 309
// module chunks = 0